import React from "react";
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { chunkArray } from "../utils";

const CHUNK_SIZE = 5;

/**
 * Renders page numbers bar with v2 design.
 *
 * @param total - total pages.
 * @param current - current page.
 * @param onClick - on page click callback.
 */
export function Pagination({ total, current, onClick, totalRecords }) {

    const prepareElements = () => {
        const result = [];
        for (let i = 0; i < total; i++) {
            result.push({
                index: i,
                name: i + 1,
                active: i === current,
                action: () => onClick(i)
            })
        }
        return result;
    }

    const paginationElements = prepareElements();
    const prevDisabled = current === 0;
    const nextDisabled = current === paginationElements.length - 1 || total === 0;

    const onNextClick = () => {
        if (nextDisabled) {
            return;
        }
        onClick(current + 1);
    }

    const onPrevClick = () => {
        if (prevDisabled) {
            return;
        }
        onClick(current - 1);
    }

    let chunkToRender = [];
    if (paginationElements.length > 0) {
        let currentChunk = Math.floor(current / CHUNK_SIZE);
        const chunks = chunkArray(paginationElements, CHUNK_SIZE);
        chunkToRender = chunks[currentChunk];
    }

    return (
        <div className="oct_pagination-v2">
            <div className="oct_pagination-info">
                {!!totalRecords && `TOTAL RECORDS: ${totalRecords}`}
            </div>
            <div className="oct_pagination-controls">
                <button
                    className="oct_pagination-btn"
                    disabled={prevDisabled}
                    onClick={onPrevClick}
                >
                    <ChevronLeft className="oct_icon" />
                </button>

                {chunkToRender.map((el, index) =>
                    <button
                        key={index}
                        className={`oct_pagination-btn ${el.active && 'active'}`}
                        onClick={el.action}
                    >
                        {el.name}
                    </button>
                )}

                <button
                    className="oct_pagination-btn"
                    disabled={nextDisabled}
                    onClick={onNextClick}
                >
                    <ChevronRight className="oct_icon" />
                </button>
            </div>
        </div>
    )
}
